import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IEmployeeAllocationFiltersState {
  searchText: string
  selectedProject: string[]
  selectedProjectManager: string[]
  selectedSkills: string[]
  selectedAllocation: string[]
}

const initialState: IEmployeeAllocationFiltersState = {
  searchText: '',
  selectedProject: [],
  selectedProjectManager: [],
  selectedSkills: [],
  selectedAllocation: []
}

export const employeeAllocationFiltersSlice = createSlice({
  name: 'employeeAllocationFilters',
  initialState,
  reducers: {
    setSearchText: (state, action: PayloadAction<string>) => {
      state.searchText = action.payload
    },
    setSelectedProject: (state, action: PayloadAction<string[]>) => {
      state.selectedProject = action.payload
    },
    setSelectedProjectManager: (state, action: PayloadAction<string[]>) => {
      state.selectedProjectManager = action.payload
    },
    setSelectedSkills: (state, action: PayloadAction<string[]>) => {
      state.selectedSkills = action.payload
    },
    setSelectedAllocation: (state, action: PayloadAction<string[]>) => {
      state.selectedAllocation = action.payload
    },
    clearAllFilters: (state) => {
      state.searchText = ''
      state.selectedProject = []
      state.selectedProjectManager = []
      state.selectedSkills = []
      state.selectedAllocation = []
    },
    setAllFilters: (
      state,
      action: PayloadAction<IEmployeeAllocationFiltersState>
    ) => {
      state.searchText = action.payload.searchText
      state.selectedProject = action.payload.selectedProject
      state.selectedProjectManager = action.payload.selectedProjectManager
      state.selectedSkills = action.payload.selectedSkills
      state.selectedAllocation = action.payload.selectedAllocation
    }
  }
})

export const {
  setSearchText,
  setSelectedProject,
  setSelectedProjectManager,
  setSelectedSkills,
  setSelectedAllocation,
  clearAllFilters,
  setAllFilters
} = employeeAllocationFiltersSlice.actions

export default employeeAllocationFiltersSlice.reducer
